<template>
  <div>
    <van-nav-bar :title="$t('app.capitalaccount.title')" class="" />
    <van-tabs id="activeTabBar" v-model="activeTab" href="1">
      <van-tab to="/create_capital_accounts">
        <template #title>
          <!-- <van-row style="width:100px;">
            <van-col span="12"
              ><img
                style="width: 38px; padding-top: 5px"
                src="../assets/images/home_day1.png"
            /></van-col>
            <van-col span="12" style="padding: 5px; padding-top: 15px"
              >配资</van-col
            >
          </van-row> -->
          <div style="display: inline-flex; align-items: center;">
            <img style="width: 30px; margin: 20px 0px" src="../assets/images/home_day1.png" alt="" />
            <p style="padding-left: 15px">{{$t("app.capitalaccount.create_capital")}}</p>
          </div>
        </template>
      </van-tab>

      <van-tab href="2">
        <template #title>
          <!-- <van-row style="width:100px;">
            <van-col span="12"
              ><img
                style="width: 38px; padding-top: 5px"
                src="../assets/images/home_month1.png"
            /></van-col>
            <van-col span="12" style="padding: 5px; padding-top: 15px"
              >交易</van-col
            >
          </van-row> -->
          <div style="display: inline-flex; align-items: center">
            <img style="width: 30px; margin: 20px 0px" src="../assets/images/home_month1.png" alt="" />
            <p style="padding-left: 15px">{{$t("app.capitalaccount.trade_capital")}}</p>
          </div>
        </template>
        <van-tabs id="activeTabSub">
          <van-tab :title="$t('app.capitalaccount.current_capital')">
            <van-list
              v-model="loadingCapitalAccount"
              :finished="finishedCapitalAccount"
              finished-text=""
              :loading-text="$t('app.common.loading')"
            >
              <van-cell-group>
                <div v-for="(item, index) in currentList" :key="index">
                  <van-cell
                    style="
                      background-color: #ff9900;
                      color: white;
                      padding: 2px 15px 10px;
                    "
                  >
                    <template #title>
                      <div>
                        <p style="margin: 0">{{ item.name }} ({{ item.order }})</p>
                        <p style="margin: 0 0 8px 0">{{ timeSplit(item.time) }}</p>

                        <div  v-if="item.direction_capital == 2" style="display: flex; justify-content: flex-end; gap: 10px">
                            <van-button
                              type="danger"
                              size="small"
                              style="border-radius: 10px; height: 26px"
                              @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'Trading', params: { direction: 0 }})"
                            >
                              {{$t("app.capitalaccount.trading")}}
                            </van-button>

                            <van-button
                              type="danger"
                              size="small"
                              style="border-radius: 10px; height: 26px"
                              @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'TradingDirection', params: { direction: 1 }})"
                            >
                              {{$t("app.capitalaccount.short_trading")}}
                            </van-button>
                            <router-link to="/account_details" style="display: flex">
                              <van-button
                                type="danger"
                                size="small"
                                style="border-radius: 10px; height: 26px"
                                @click="goAccountDetails(item.cid)"
                              >
                                {{$t("app.capitalaccount.information")}}
                              </van-button>
                            </router-link>
                        </div>
                        <div  v-if="item.direction_capital == 1" style="display: flex; justify-content: flex-end; gap: 10px">
                            <van-button
                              type="danger"
                              size="small"
                              style="border-radius: 10px; height: 26px"
                              @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'TradingDirection', params: { direction: 1 }})"
                            >
                              {{$t("app.capitalaccount.short_trading")}}
                            </van-button>
                            <router-link to="/account_details" style="display: flex">
                              <van-button
                                type="danger"
                                size="small"
                                style="border-radius: 10px; height: 26px"
                                @click="goAccountDetails(item.cid)"
                              >
                                {{$t("app.capitalaccount.information")}}
                              </van-button>
                            </router-link>
                        </div>
                        <div  v-if="item.direction_capital == 0" style="display: flex; justify-content: flex-end; gap: 10px">
                            <van-button
                              type="danger"
                              size="small"
                              style="border-radius: 10px; height: 26px"
                              @click="$store.commit('setSelectedCid', item.cid); $router.push({ name: 'Trading', params: { direction: 0 }})"
                            >
                              {{$t("app.capitalaccount.trading")}}
                            </van-button>
                            <router-link to="/account_details" style="display: flex">
                              <van-button
                                type="danger"
                                size="small"
                                style="border-radius: 10px; height: 26px"
                                @click="goAccountDetails(item.cid)"
                              >
                                {{$t("app.capitalaccount.information")}}
                              </van-button>
                            </router-link>
                        </div>

                      </div>
                    </template>
                  </van-cell>
                  <van-cell :title="$t('app.capitalaccount.total_asset')" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: black">{{ item.total }}{{$t("app.common.currency")}}</span>
                    </template>
                  </van-cell>
                  <van-cell :title="$t('app.capitalaccount.loss_warning')" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: #ff2c27">{{ item.warning }}{{$t("app.common.currency")}}</span>
                    </template>
                  </van-cell>
                  <van-cell  :title="$t('app.capitalaccount.loss_liquidation')" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: #008000">{{ item.close }}{{$t("app.common.currency")}}</span>
                    </template>
                  </van-cell>
                  <van-cell  :title="$t('app.capitalaccount.risk_margin')" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: black">{{ item.bond }}{{$t("app.common.currency")}}</span>
                    </template>
                  </van-cell>
                  <van-cell  :title="$t('app.capitalaccount.profit_loss')" style="padding: 5px 16px">
                    <template #default>
                      <span v-if="item.profit_loss < 0" style="color: #008000"
                        >{{ item.profit_loss }}{{$t("app.common.currency")}} ({{ item.proportion }}%)</span
                      >
                      <span v-else style="color: #ff2c27"
                        >{{ item.profit_loss }}{{$t("app.common.currency")}} ({{ item.proportion }}%)</span
                      >
                    </template>
                  </van-cell>
                  <van-cell  :title="$t('app.capitalaccount.balance')" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: #ff2c27">{{ item.use }}{{$t("app.common.currency")}}</span>
                    </template>
                  </van-cell>
                </div>
              </van-cell-group>
            </van-list>
          </van-tab>
          <van-tab :title="$t('app.capitalaccount.history_capital')">
            <van-cell-group>
              <router-link to="/closed_capital_info">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                  @click="goDetails(item.cid)"
                >
                  <van-cell>
                    <van-row>
                      <van-col span="24">
                        <span style="font-size: 15px; color: black"
                          >{{ item.name }}({{ item.order }})</span
                        >
                      </van-col>
                    </van-row>
                    <van-row style="line-height: 21px;">
                      <van-col span="20">
                        <van-row>
                          <van-col span="24">
                            <span style="font-size: 13px; color: #808080">{{
                              timeSplit(item.time)
                            }}</span>
                          </van-col>
                        </van-row>
                        <van-row>
                          <van-col span="12">
                            <span style="font-size: 13px; color: #808080"
                              >{{$t("app.capitalaccount.total_capital_allocation")}}:{{ item.total }}</span
                            >
                          </van-col>
                          <van-col span="12">
                            <span style="font-size: 13px; color: #808080"
                              >{{$t("app.capitalaccount.risk_margin")}}:{{ item.bond }}</span
                            >
                          </van-col>
                        </van-row>
                        <van-row>
                          <van-col span="24">
                            <span style="font-size: 15px; color: black"
                              >{{$t("app.capitalaccount.cumulative_profit_loss")}}:</span
                            ><span v-bind:class="[item.profit >= 0 ? 'redText' : 'greenText']" style="font-size: 15px; padding-left: 10px;">{{
                              item.profit
                            }}</span>
                          </van-col>
                        </van-row>
                      </van-col>
                      <van-col span="4">
                        <van-row>
                          <van-col span="24" style="text-align: right">
                            <img
                              style="height: 50px; width: 50px"
                              src="../assets/images/over.png"
                            />
                          </van-col>
                        </van-row>
                      </van-col>
                    </van-row>
                  </van-cell>
                </div>
              </router-link>
            </van-cell-group>
          </van-tab>
        </van-tabs>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "CapitalAccount",
  mounted: function () {
    this.getHistoryData();
    this.getNowData();
    this.isActiveTab();
    this.activeTab = this.tabs.findIndex(
      (tab) => tab === this.$route.query.activeTab
    );
  },
  data() {
    return {
      activeTab: "0",
      tabs: ["1", "2"],
      list: [],
      currentList: [],
      loadingCapitalAccount: false,
      finishedCapitalAccount: false,
    };
  },
  methods: {
         timeSplit(time){
        const time_split=time.split('~');
      const create_time=this.$getDeviceDate(time_split[0]); 
      const renew_time=time_split[1]; 
      return create_time+'~'+renew_time;
      },
    isActiveTab() {
      let that = this;
      if (!that.$route.query.activeTab) {
        that.activeTab = "2";
      } else {
        that.activeTab = that.$route.query.activeTab;
      }
    },
    getHistoryData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "history_operate",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.list = res.data.data;
            // if (that.list.length == 0) {
            //   that.$toast({
            //     message: "暂无记录",
            //     type: "warning",
            //   });
            // }
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
    getNowData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.currentList = res.data.data;
            that.loadingCapitalAccount = false;
            that.finishedCapitalAccount = true;
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          } else if (res.data.code == -1) {
            that.$logout(that.$t(res.data.msg));
          }
        })
        .catch(()=>{
          that.loadingCapitalAccount = false;
          that.finishedCapitalAccount = true;
        });
    },
    //去详情
    goDetails(cid) {
      window.sessionStorage.setItem("cid", cid);
      this.$router.push({
        path: "/closed_capital_info",
      });
    },
    goAccountDetails(cid) {
      window.sessionStorage.setItem("cid", cid);
      this.$router.push({
        path: "/account_details",
      });
    },
  },
};
</script>
<style>
#activeTabBar .van-tab--active {
  border: 1px solid #ee0d25 !important;
}

#activeTabBar .van-tabs__line {
  display: none;
}

#activeTabSub .van-tab--active {
  border: none !important;
  border-bottom: 1px solid #ee0d25 !important;
}
</style>
<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
.redText {
  color: #ff2c27;
}
.greenText {
  color: #008000;
}
</style>


// WEBPACK FOOTER //
// src/components/CapitalAccount.vue